module.exports = __webpack_public_path__ + "static/media/babu.a154eb47.jpg";